import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { BankAccountLine } from 'src/app/@shared/models/banking/bank-account-lines/bank-account-line.model';
import { BankStatementLine } from 'src/app/@shared/models/banking/statements/bank-statement-line.model';
import { GeneralFactory } from 'src/app/@shared/models/factories/general-factory';
import { QueryOptionsParam } from 'src/app/@shared/utilities/odata/query-params';

const CLASS_NAME = 'BankStatementLine';
const ENDPOINT = `/bank-statement-lines/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'candidates', path: 'candidates/', childClass: 'BankAccountLine' },
]
const ROUTES: RouteParam[] = [
    { key: 'link',   path: '{id}/link/' },
    { key: 'unlink', path: '{id}/unlink/' },
    { key: 'import', path: '{id}/import/' },
]

@Injectable({
    providedIn: 'root'
})
export class BankStatementLineService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public getCandidates$(lineId: number, options?: QueryOptionsParam): Observable<BankAccountLine[]> {
        return this.getRelated$({ id: lineId }, 'candidates', options) as Observable<BankAccountLine[]>;
    }

    /** Crée la transaction dans Biifor depuis la ligne PDF : la valeur renvoyée est une `BankAccountLine`, pas une ligne de relevé */
    public import$(lineId: number): Observable<BankAccountLine> {
        const url = this.routes['import'].replace('{id}', lineId.toString());
        return this._postActionValue$(url).pipe(
            map((value: any) => GeneralFactory.get('BankAccountLine', value) as BankAccountLine)
        );
    }

    public link$(lineId: number, bankAccountLineId: number): Observable<BankStatementLine> {
        const url = this.routes['link'].replace('{id}', lineId.toString());
        return this._putAction$<BankStatementLine>(url, { bankAccountLineId });
    }

    public unlink$(lineId: number): Observable<BankStatementLine> {
        const url = this.routes['unlink'].replace('{id}', lineId.toString());
        return this._putAction$<BankStatementLine>(url);
    }
}
